module.exports = __webpack_public_path__ + "static/img/b.d0946e3e.png";